
import Vue from './components/common/vue'

import i18n from './components/i18n';
import TopbarLogin from "./components/header/TopbarLogin";



/* eslint-disable no-new */
new Vue({
    el: '#topbar-login',
    template: '<TopbarLogin/>',
    components: {
        TopbarLogin
    },
    i18n
});



// WEBPACK FOOTER //
// ./src/headerauth.js